import { render, staticRenderFns } from "./EquiposFilters.vue?vue&type=template&id=55f31999"
import script from "./EquiposFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./EquiposFilters.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports